import { ProductImage } from './productImage.model';
import { Child } from './child.model';
import { ProductExtension } from './productExtension.model';
export class Product extends ProductExtension {
    _id: string;
    productName: string;
    productId: string;
    manufactureInfo: string;
    vendorId: string;
    brandName: string;
    hsnCode: string;
    ttsPortalenable:boolean;
    gstIn: string;
    variantId: string;
    variationTypeId: string;
    colorFields: any;
    costIncludes: string | [string];
    sizeVariantId: string;
    sizeVariant: string;
    headChild: boolean;
    sku: string;
    styleCode: string;
    price: number;
    variation: string;
    productsType: string;
    tailoringService:string;
    packOf: number;
    size: string;
    weight: string;
    fabric: string;
    washCare: string;
    productDimension: string;
    packingDimension: string;
    selectedColorMain: string;
    discount: number;
    sp: number;
    mrp: string;
    bulletPoints: string;
    closure: string;
    pattern: string;
    productDescription: string | [string];
    toFitWaist: string;
    searchTerms1: string;
    searchTerms2: string;
    searchTerms3: string;
    searchTerms4: string;
    searchTerms5: string;
    superCategoryId: string;
    superCategoryName: string;
    mainCategoryId: string;
    mainCategoryName: string;
    subCategoryId: string;
    subCategoryName: string;
    color: string;
    colorId: string;
    tags: string;
    metaTitle: string;
    metaDescription: string;
    metaKeyword: string;
    dateAdded: Date;
    dateModified: Date;
    brandId: string;
    variationType: string;
    publish: boolean;
    sizeName: string;
    sizeId: string;
    quantity: number;
    variantQuantity: number;
    variantPrice: number;
    productImage: [ProductImage];
    attribute: any;
    length: string;
    breath: string;
    hsn: string;
    child: [Child];
    tp: string;
    ttsPortol: string;
    ttsVendor: string;
    wishList: boolean;
    minPrice: number;
    maxPrice: number;
    discountStyle: string;
    oldPrice: number;
    INTsku: string;
    savePrice: number;
    totalPrice: number;
    readyToWear: boolean;
    attributeId: string;
    searchId:string;
    sizeIncApply: boolean;
    sizeIncType: string;
    sizeWisePrice: number;
    enhancementTemplateId: string;
    queryParams: {cid: string};
    childId: string;
    totalQuantity: [number];
    isOutOfStock: boolean;
}
